import Stack from '@mui/material/Stack'
import Typography from '@components/_mui/Typography'

export default function Property({ label, sx = {}, children }) {
  return (
    <Stack
      sx={[
        {
          minHeight: 36,
          gap: { xs: 0, md: 1 },
          flexDirection: { xs: 'column', md: 'row' },
          alignItems: { xs: 'flex-start', md: 'center' },
          flexWrap: 'nowrap',
        },
        sx,
      ]}
    >
      {['string', 'number'].includes(typeof label) ? (
        <Typography sx={{ minWidth: 100, color: 'text.secondary' }}>{label}</Typography>
      ) : (
        label
      )}
      {children}
    </Stack>
  )
}
